var map = {
	"./en.json": "./src/assets/json/countries/en.json",
	"./fr.json": "./src/assets/json/countries/fr.json",
	"./nl-be.json": "./src/assets/json/countries/nl-be.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/json/countries sync recursive ^\\.\\/.*\\.json$";